<template>
    <div class="my-body">
        <!--个人信息--->
        <div class="start-destination-class">
            <div class="filghts-line-text"><span>{{type==='add'?'添加':(type==='update'?'修改':'')}}出行人信息</span></div>
        </div>
        <div class="form-div-parent">
            <div class="form-div" :style="{minHeight:(type==='add'?'calc( 100vh - 4em - 50px )':'')}">

                <div>
                    <div class="form-item">
                        <div>手机号<span style="color:red;">*</span></div>
                        <div>
                            <van-field
                            type="number"
                            v-model="mobile" placeholder="请输入手机号"
                            :border="false"
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div class="form-item">
                        <div>会员姓名<span style="color:red;">*</span></div>
                        <div>
                            <van-field
                            v-model="name" placeholder="请输入会员姓名"
                            :border="false"
                            />
                        </div>
                    </div>
                </div>
                <div v-show="certType===2">
                    <div class="form-item">
                        <div>姓<span style="color:red;">*</span></div>
                        <div>
                            <van-field
                            v-model="surname" placeholder="请输入英文姓"
                            :border="false"
                            />
                        </div>
                    </div>
                </div>
                <div v-show="certType===2">
                    <div class="form-item">
                        <div>名<span style="color:red;">*</span></div>
                        <div>
                            <van-field
                            v-model="givenName" placeholder="请输入英文名"
                            :border="false"
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div class="form-item" @click="countryFunc" >
                        <div>国籍<span style="color:red;">*</span></div>
                        <div>
                            <van-field
                            v-model="nationality" placeholder="请选择国籍" readonly="readonly"
                            :border="false"
                            />
                            <img  src="../../../assets/flights/o_icon_Expand_right2_20px_@2x.m.png" />
                        </div>
                    </div>
                </div>
                <div>
                    <div class="form-item" @click.capture="IDCardSelectShowFunc">
                        <div>证件类型<span  style="color:red;">*</span></div>
                        <div>
                            <van-field
                            v-model="certTypeValue" placeholder="请选择证件类型" readonly="readonly"
                            :border="false"
                            />
                            <img  src="../../../assets/flights/o_icon_Expand_right2_20px_@2x.m.png"  />
                        </div>
                    </div>
                </div>
                <div>
                    <div class="form-item">
                        <div>证件号<span style="color:red;">*</span></div>
                        <div>
                            <van-field
                            v-model="idCard" placeholder="请输入证件号"
                            :border="false"
                            />
                        </div>
                    </div>
                </div>
                <div v-show="certType===2">
                    <div class="form-item" @click.capture="expireDateShowFunc">
                        <div>过期时间<span style="color:red;">*</span></div>
                        <div>
                            <van-field
                            v-model="expireDate" type="string" placeholder="请选择证件过期时间" readonly="readonly"
                            :border="false"
                            />
                            <img  src="../../../assets/flights/o_icon_Expand_right2_20px_@2x.m.png"  />
                        </div>
                    </div>
                </div>
                <div v-show="certType===2">
                    <div class="form-item-radio">
                        <div>性别<span  style="color:red;">*</span></div>
                        <div>
                            <div style="box-sizing:border-box;padding-left:1em;" v-for="(itemChild,indexChild) in radioList" :key="indexChild">
                                <jlkj-radio  v-model="itemChild.checked"  @change="theRadioList" :groupIndex="indexChild.toString()" />
                                <div>{{itemChild.label}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="certType===2">
                    <div  class="form-item"  @click.capture="birthdayShowFunc">
                        <div>出生日期<span  style="color:red;">*</span></div>
                        <div>
                            <van-field
                            v-model="birthday" type="string" placeholder="请选择出生日期" readonly="readonly"
                            :border="false"
                            />
                            <img  src="../../../assets/flights/o_icon_Expand_right2_20px_@2x.m.png" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-list-div">
                <div >
                    <div class="btn-blue-k" style="width:calc( 50% - 40px );" @click="back">取消</div>
                    <div class="btn-blue" style="width:calc( 50% - 40px );" @click="changeBoolen('confirmWindowShow',true)" >确定</div>
                </div>
                <div>
                    <div v-if="type==='update'" class="btn-blue-k" style="width: 100% ;" @click="deleteClick" >删除</div>
                </div>
            </div>
        </div>
        <div class="user-mess-border" v-show="confirmWindowShow">
            <div class="user-mess-body">
                <div class="head-title">确认信息</div>
                <div class="mess-text" v-if="this.$route.query.source === 'cruise'">请谨慎核对所填写的<span v-if="this.$route.query.addType">联系人</span><span v-else>出行人</span>信息。</div>
                <div class="mess-text" v-else><span style="color:#3377FF;">姓名顺序和拼写错误</span>可能导致退票重新购票证件号码错误将无法登机，请谨慎核对。</div>
                <div class="user-message">
                    <div class="flex-start"><div class="label-str">姓名</div><div class="value-str">{{name}}</div></div>
                    <!-- <div class="flex-start"><div class="label-str">生日</div><div class="value-str">{{birthday}}</div></div> -->
                    <div class="flex-start"><div class="label-str">证件号</div><div class="value-str">{{idCard}}</div></div>
                </div>
                <div class="flex-between">
                    <div class="btn-blue-k"  @click="changeBoolen('confirmWindowShow',false)">
                        返回修改
                    </div>
                    <div class="btn-blue"  @click="flightsPersonalChange">
                        确认无误
                    </div>
                </div>
            </div>
        </div>
        <div v-show="expireDateShow" class="fixed-class">
            <div class="view-hw-bg" @click.self="changeBoolen('expireDateShow',false)">
                <div>
                    <van-datetime-picker
                    @confirm="changeExpireDate_Date"
                    @cancel="changeBoolen('expireDateShow',false)"
                    v-model="expireDate_Date"
                    type="date"
                    title="选择过期时间"
                    :min-date="expireDateMinDate"
                    :max-date="expireDateMaxDate"/>
                </div>
            </div>
        </div>
        <div v-show="birthdayShow" class="fixed-class">
            <div class="view-hw-bg" @click.self="changeBoolen('birthdayShow',false)">
                <div>
                    <van-datetime-picker
                    @confirm="changeBirthday_Date"
                    @cancel="changeBoolen('birthdayShow',false)"
                    v-model="birthday_Date"
                    type="date"
                    title="选择出生日期"
                    :min-date="birthdayMinDate"
                    :max-date="birthdayMaxDate"/>
                </div>
            </div>
        </div>
        <div v-show="IDCardSelectShow" class="fixed-class">
            <div class="view-hw-bg" @click.self="changeBoolen('IDCardSelectShow',false)">
                <div>
                    <div class="between-center-flex">
                        <div @click="changeBoolen('IDCardSelectShow',false)" class="cancel-btn">取消</div>
                        <div class="title-div-font">证件类型</div>
                        <div @click="IDCardSelectShowConfirm" class="confirm-btn">确定</div>
                    </div>
                    <div class="border-div">
                        <div>
                            <div  v-for="(item,index) in IDCardSelectArray" :key="index"  :class="{'border-son-div':true,'now-border-son-div':(index==idCardIndex)}"  @click="idType(index)">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="countryShow" class="fixed-class">
            <div class="view-hw-bg" @click.self="changeBoolen('countryShow',false)">
                <div>
                    <div class="between-center-flex">
                        <div @click="changeBoolen('countryShow',false)" class="cancel-btn">取消</div>
                        <div class="title-div-font">国籍</div>
                        <div @click="selectCountryConfirm" class="confirm-btn">确定</div>
                    </div>
                    <div class="border-div" ref="the-country-select">
                        <div>
                            <div v-for="(item,index) in country" :id="'country_'+index" :key="index" :class="{'border-son-div':true,'now-border-son-div':(index===countryIndex)}" @click="selectCountry(index)">{{item.zhName}}</div>
                            <!-- +'('+item.enName+')' -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <jlkj-popup ref="popup" v-show="windowShow" :message="thisMessage" :type="'center'"></jlkj-popup>
    </div>
</template>
<script>
import {Dialog} from 'vant';
import JlkjPopup from '../../../components/jlkj-popup.vue';
import JlkjRadio from '../../../components/jlkj-radio.vue';
import {new_Date} from '../../../utils/new_date';


export default {
    name:"personal-information",
    components:{
        JlkjRadio,
        JlkjPopup
    },
    data(){
        return {
            defaultCountryIndex:'',
            type:'',
            thisMessage:'',
            windowShow:false,
            allReady:false,
            birthdayMaxDate:new_Date(),
            birthdayMinDate:new_Date(1900,0,1),
            expireDateMinDate:new_Date(),
            expireDateMaxDate:new_Date(),
            confirmWindowShow:false,
            id:'',
            name:'',
            surname:'',
            givenName:'',
            nationality:'中国',
            certTypeValue:'身份证',
            certType:1,
            idCard:'',
            expireDate_Date:new_Date(),
            birthday_Date:new_Date(2000,0,1),
            expireDate:'',
            birthday:'',
            sex:'',
            mobile:'',
            country:[],
            countryObjTemp:{},
            //countryValue:'',
            expireDateShow:false,
            expireDateIndex:-1,
            birthdayShow:false,
            birthdayIndex:-1,
            IDCardSelectShow:false,
            IDCardSelectString:'',
            nationalitySelectShow:false,
            nationalitySelectIndex:-1,
            countryShow:false,
            countryIndex:-1,
            countryNowIndex:-1,
            idCardIndex:-1,
            idCardNowIndex:-1,
            radioList:[
                        {label:'男',checked:false,value:'1'},
                        {label:'女',checked:false,value:'2'}
                    ],
            IDCardSelectArray:[
                {
                    name:"身份证",
                    value:1
                },
                // {
                //     name:"护照",
                //     value:2
                // },
                // {
                //     name:"军官证"
                // },
                // {
                //     name:"台胞证"
                // },
                // {
                //     name:"港澳通行证"
                // },
            ]
        }
    },
    watch:{

    },
    created(){
    },
    mounted(){
        console.log(this.$route, 'this.$route.query.addTypethis.$route.query.addTypes')
        this.isAddOrUpdate();
        this.getCountry();
        let date=new_Date();
        date.setFullYear(
            (date.getFullYear() + 100)
            // + '-' +
            // (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-' +
            // (date.getDate()<10?'0'+date.getDate():date.getDate())
        );
        this.expireDateMaxDate=date;
    },
    methods:{

        birthdayShowFunc(){
            if(this.birthday!==''){
                this.birthday_Date=new_Date(this.birthday);
            }
            this.changeBoolen('birthdayShow',true);
        },
        IDCardSelectShowFunc(){
            this.idCardIndex=this.idCardNowIndex
            this.changeBoolen('IDCardSelectShow',true);
        },
        countryFunc(){
            // if(this.countryIndex===-1){
            //     this.$nextTick(()=>{
            //         this.$refs['the-country-select'].scrollTo(0,this.defaultCountryIndex*50)
            //     })
            // }
            this.countryIndex=this.countryNowIndex;
            this.changeBoolen('countryShow',true);
        },
        expireDateShowFunc(){
            if(this.expireDate===null||this.expireDate===''){
                this.expireDate_Date=new_Date(this.expireDateMinDate);
            }else{
                this.expireDate_Date=new_Date(this.expireDate);
            }
            this.changeBoolen('expireDateShow',true);
        },
        // birthdayShowFunc:function(){this.changeBoolen('birthdayShow',true);},

        isAddOrUpdate(){
            this.type=this.$route.query.type;
            if(this.type==='add'){
                this.isAddPage();
            }else if(this.type==='update'){
                this.isUpdatePage();
            }
        },
        isAddPage:function(){

        },
        isUpdatePage:function(){
            let tempValue=this.IDCardSelectArray.filter((item)=>{
                return item.value===parseInt(this.$route.query.idCardNowIndex);
            })[0];
            for(let i=0;i<this.radioList.length;i++){
                if(this.radioList[i].value===this.$route.query.sex){
                    this.radioList[i].checked=true;
                    this.sex=this.radioList[i].value;
                    break;
                }
            }

            this.id=this.$route.query.id;
            this.name=this.$route.query.name;
            this.surname=this.$route.query.surname;
            this.givenName=this.$route.query.givenName;
            this.nationality=this.$route.query.nationality;
            this.certTypeValue=tempValue===undefined?'':tempValue.name;
            this.certType=parseInt(this.$route.query.idCardNowIndex);
            this.idCard=this.$route.query.certNo;
            this.expireDate=this.$route.query.expireDate?this.$route.query.expireDate.split(' ')[0]:'';
            this.birthday=this.$route.query.birthday?this.$route.query.birthday.split(' ')[0]:'';
            this.mobile=this.$route.query.mobile;

        },

        changeBoolen:function(str,bool){
            this[str]=bool;
        },

        IDCardSelectShowConfirm:function(){
            this.certTypeValue=this.IDCardSelectArray[this.idCardIndex].name;
            this.idCardNowIndex=this.idCardIndex;
            this.certType=this.IDCardSelectArray[this.idCardIndex].value;
            this.changeBoolen('IDCardSelectShow',false);
        },

        initData:function(id){

        },
        // addResultData:function(){
        //     for(let i=0;i<inputList.length;i++){
        //         this.resultData[this.inputList[i].key]=this.inputList[i].modelValue;
        //     }
        // },
        theRadioList:function(value,index){
            if(value===true){

                for(let j=0;j<this.radioList.length;j++){
                    if(j===parseInt(index)){
                        this.radioList[j].checked=true;
                        this.sex=this.radioList[j].value.toString();
                        continue;
                    }
                    this.radioList[j].checked=false;
                }

            }
        },
        beforeInitData:function(){

            this.expireDateMinDate=this.expireDateMinDate.setFullYear(this.expireDateMinDate.getFullYear+100);

            this.type=decodeURI(this.$route.query.type);
            this.name=decodeURI(this.$route.query.name);
            this.certType=decodeURI(this.$route.query.certType);
            this.idCard=decodeURI(this.$route.query.certNo);
            this.mobile=decodeURI(this.$route.query.mobile);
            this.sex=decodeURI(this.$route.query.sex);
            this.birthday=decodeURI(this.$route.query.birthday);
            this.expireDate=decodeURI(this.$route.query.expireDate);

            this.allReady=true;
        },
        flightsPersonalChange(){
            this.check();


        },
        check(){
            let messageText='';
            let body=[
                {value:this.mobile,msg:"请输入手机号",tab:[1,2]},
                {value:this.name,msg:"请输入姓名",tab:[1,2]},
                {value:this.surname,msg:"请输入英文姓",tab:[2]},
                {value:this.givenName,msg:"请输入英文名",tab:[2]},
                {value:this.nationality,msg:"请选择国籍",tab:[1,2]},
                {value:this.idCard,msg:"请输入证件号",tab:[1,2]},
                {value:this.expireDate,msg:"请选择证件号日期",tab:[2]},
                {value:this.sex,msg:"请选择性别",tab:[2]},
                {value:this.birthday,msg:"请输入生日",tab:[2]}
            ];
            for(let i=0;i<body.length;i++){
                if(body[i].value===""&&body[i].tab.indexOf(this.certType)!==-1){
                    messageText=body[i].msg;
                    break;
                }
            }


            if(messageText===''){

                if(this.type==='update'){
                    this.updateFlightsPersonal();
                }else if(this.type==='add'){
                    this.setFlightsPersonal();
                }
            }else{
                this.thisMessage=messageText;
                this.windowShow=true;
                this.$refs['popup'].readyHide(()=>{
                    this.windowShow=false;
                });
            }
        },
        setFlightsPersonal:function(){
            let sexArray=this.radioList.filter((item)=>{
                    return item.checked===true
                });
            let body={
                "surname": this.surname,
	            "givenName": this.givenName,
                "nationality":this.nationality,
                "certType":this.certType,
                "expireDate": this.expireDate,
                "idCard": this.idCard,
                "mobile": this.mobile,
                "name": this.name,
                "sex": this.sex,//sexArray.length!==0?sexArray[0].value:'',
                "birthday":this.birthday
            };
            let params={
                isTourist:this.$route.query.addType ? parseInt(this.$route.query.addType) : 1
            };
            let tipText = '提交乘机人成功，即将自动跳转至提交订单页面';
            let errText = '提交乘机人错误：';
            if (this.$route.query.source === 'cruise') {
                if (this.$route.query.addType) {
                    tipText = '提交联系人成功，即将自动跳转至联系人列表页面';
                    errText = '提交联系人错误：';
                } else {
                    tipText = '提交出行人成功，即将自动跳转至出行人列表页面';
                    errText = '提交出行人错误：';
                }
            };
            this.$API.flights.setFlightsPersonal(params,body)
            .then((res)=>{
                if(res.code===200){
                    // this.thisMessage="提交乘机人成功，即将自动跳转至提交订单页面";
                    this.thisMessage=tipText;
                    this.windowShow=true;
                    this.$refs['popup'].readyHide(()=>{
                        this.windowShow=false;
                        sessionStorage.setItem('passengers-list-back','0');
                        if(this.type==='add'){
                            this.$router.go(-1);
                        }else{
                            this.$router.back();
                        }
                    });
                }else{
                    // this.thisMessage="提交乘机人错误："+res.msg;
                    this.thisMessage=`${errText}`+res.msg;
                    this.windowShow=true;
                    this.$refs['popup'].readyHide(()=>{
                        this.windowShow=false;
                    });
                }
            })
            .catch((err)=>{
                    // this.thisMessage="提交乘机人错误："+res.msg;
                    this.thisMessage=`${errText}`+res.msg;
                    this.windowShow=true;
                    this.$refs['popup'].readyHide(()=>{
                    this.windowShow=false;
                });
            })
        },
        updateFlightsPersonal:function(){
            let sexArray=this.radioList.filter((item)=>{
                    return item.checked===true
                });
            let body={
                "id":this.id,
                "surname": this.surname,
	            "givenName": this.givenName,
                "nationality":this.nationality,
                "certType":this.certType,
                "expireDate": this.expireDate,
                "idCard": this.idCard,
                "mobile": this.mobile,
                "name": this.name,
                "sex": this.sex,//sexArray.length!==0?sexArray[0].label:'',
                "birthday":this.birthday
            };
            let params={
                isTourist:this.$route.query.addType ? parseInt(this.$route.query.addType) : 1
            };
            let tipText = '提交乘机人成功，即将自动跳转至提交订单页面';
            let errText = '提交乘机人错误：';
            if (this.$route.query.source === 'cruise') {
                if (this.$route.query.addType) {
                    tipText = '提交联系人成功，即将自动跳转至联系人列表页面';
                    errText = '提交联系人错误：';
                } else {
                    tipText = '提交出行人成功，即将自动跳转至出行人列表页面';
                    errText = '提交出行人错误：';
                }
            };
            this.$API.flights.updateFlightsPersonal(params,body)
            .then((res)=>{
                if(res.code===200){
                    // this.thisMessage="提交乘机人成功，即将自动跳转至提交订单页面";
                    this.thisMessage=tipText;
                    this.windowShow=true;
                    sessionStorage.setItem('passengers-list-back','0');
                    // if(this.type==='add'){
                        sessionStorage.setItem('flights-passenger-add-back','0');
                        // this.$router.go(-1);
                    // }else{
                    //     // sessionStorage.setItem('passengers-list-back','0');
                    //     sessionStorage.setItem('flights-passenger-add-back','2');
                    // }
                    this.$refs['popup'].readyHide(()=>{
                        this.windowShow=false;
                        if(this.type==='add'){
                            this.$router.go(-1);
                        }else{
                            this.$router.back();
                        }
                    });
                }else{
                    // this.thisMessage="提交乘机人错误："+res.msg;
                    this.thisMessage=`${errText}`+res.msg;
                    this.windowShow=true;
                    this.$refs['popup'].readyHide(()=>{
                        this.windowShow=false;
                    });
                }
            })
            .catch((err)=>{
                    // this.thisMessage="提交乘机人错误："+res.msg;
                    this.thisMessage=`${errText}`+res.msg;
                    this.windowShow=true;
                    this.$refs['popup'].readyHide(()=>{
                    this.windowShow=false;
                });
            })
        },
        back(){
            this.$router.back();
        },
        getCountry(){
            this.$API.flights.getCountry().then(res=>{
                if(res.code===200){
                    let defaultCountryStr='中国';
                    let tempItem=null;
                    this.country=res.data;
                    for(let i=0;i<this.country.length;i++){
                        if(this.country[i].zhName===defaultCountryStr){
                            // this.defaultCountryIndex=i;
                            this.countryNowIndex===i;
                            tempItem=JSON.parse(JSON.stringify(this.country[i]));
                        }
                    }
                    this.country.unshift(tempItem);
                }
            })
        },
        idType(index){
            this.idCardIndex=index;
            //this.certType=this.IDCardSelectArray[index].value;
            //this.certTypeStr=this.IDCardSelectArray[index].name;
        },
        changeExpireDate_Date(){
            let date = this.expireDate_Date;
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            let D = (date.getDate()<10?'0'+date.getDate():date.getDate());
            this.expireDate=Y+M+D;
            this.changeBoolen('expireDateShow',false);
        },
        changeBirthday_Date(){
            let date = this.birthday_Date;
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            let D = (date.getDate()<10?'0'+date.getDate():date.getDate());
            this.birthday=Y+M+D;
            this.changeBoolen('birthdayShow',false);
        },
        selectCountry(index){

            this.countryObjTemp=this.country[index];
            this.countryIndex=index;

        },
        selectCountryConfirm(){
            this.nationality=this.countryObjTemp.zhName;
            this.countryNowIndex=this.countryIndex;

            this.countryShow=false;
        },
        deleteClick(){
            Dialog.confirm({
                title: '删除提示',
                message: '是否删除该联系人？',
                confirmButtonColor:'#3377FF'
            }).then(() => {
                this.deleteIt();

            });
        },
        deleteIt(){
            let query={
                idList:""
            };
            let theIdList=this.id;
            // for(let item in this.mainData){
            //     if(this.mainData[item].checked){
            //         theIdList+=','+this.mainData[item].id;
            //     }
            // }
            query.idList=theIdList;
            this.$API.flights.deleteTravelerByIdList(query)
            .then((res)=>{
                    if(res.code===200){
                        this.thisMessage="删除成功";
                        this.windowShow=true;
                        sessionStorage.getItem('item-delete','1');
                        this.$refs['popup'].readyHide(()=>{
                            this.windowShow=false;
                            this.$router.back();
                        })

                    }else{
                        this.thisMessage="删除失败";
                        this.windowShow=true;
                        this.$refs['popup'].readyHide(()=>{
                            this.windowShow=false;
                        })
                    }
                })
                .catch(()=>{
                        this.thisMessage="发生错误，请刷新重试";
                        this.windowShow=true;
                        this.$refs['popup'].readyHide(()=>{
                            this.windowShow=false;
                        })
                })
        },
        new_Date
    }
}
</script>
<style scoped>
    .start-destination-class{
        width:100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        /* position: fixed;
        left: 0;
        top: 0;
        z-index: 199; */
    }
    .filghts-line-text{
        box-sizing: border-box;
        padding:0.25em 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        color: #2E3033;
    }
    .my-body{
        background-image: url('../../../assets/flights/bg-img.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-color:#F4F6F9;
        min-height: 100vh;
    }
    .form-div{
        margin-top:15px;
        box-sizing:border-box;
        background-color: #FFFFFF;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        min-height: calc( 100vh - 4em - 90px );
    }
    .form-div-parent{
        min-height: calc( 100vh - 4em );
        position: relative;
        left: 0;
        top:0;
    }
    .form-div-parent > div:first-child > div:last-child > div{
        border-bottom:0px;
    }
    .form-item,.form-item-radio{
        width:calc( 100% - 20px );
        margin:0 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom:1px solid #E6EAF2;
    }
    .form-item > div:first-child,.form-item-radio > div:first-child{
        width:6em;
        /* margin:1em 0; */
        font-size: 15px;
        color: #2E3033;
    }
    .form-item > div:nth-child(2),.form-item-radio > div:nth-child(2){
        width:calc( 100% - 6em );
        /* margin:1em 0 ; */
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .form-item-radio > div:first-child{
        margin:1em 0;
    }
    .form-item > div:nth-child(2) > input:nth-child(1){
        width:100% ;
        border-color:rgba(0,0,0,0);
    }
    .form-item-div-other{
        width:calc( 100% - 2em );
    }
    .form-item > div > img{
        width:0.75em;
        height:0.75em;
        margin:0.5em;
    }
    .form-item-radio > div:nth-child(2)  {
        flex-wrap: wrap;
    }
    .form-item-radio > div:nth-child(2) > div  {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right:0.75em;
    }
    .form-item-radio > div:nth-child(2) > div > div {
        margin-right:0.25em;
    }
    .btn-blue-k{
        border: 1px solid #3377FF;
        border-radius: 4px;
        color:#3377FF;
        display: flex;
        justify-content: center;
        align-items: center;
        padding:0 1em;
        height: 34px;
    }
    .btn-blue{
        border: 1px solid #3377FF;
        background-color: #3377FF;
        border-radius: 4px;
        color:#FFFFFF;
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding:0 1em;
    }
    .bottom-list-div{
        padding:0 10px ;
        align-items: center;
        box-sizing: border-box;
    }
    .bottom-list-div > div{
        display: flex;
        justify-content: space-between;
        margin-bottom:10px;
    }
    .form-div-parent{
        background:#FFFFFF;
        border-radius: 10px;
        margin:0 10px;
    }
    .value-str{
        width:calc( 100% - 30px - 5rem );
    }
    .label-str{
        width:5rem;
    }
    .mess-text{
        font-size: 14px;
        color: #676A71;
    }
    .flex-start{
        display: flex;
        justify-content: start;
        align-items: center;
        margin:10px 0;
    }
    .user-message{
        background: #F5F7FA;
        border-radius: 4px;
        padding:10px 15px;
        color: #5C5F66;
        font-size:14px;
    }
    .user-mess-body{
        width: calc( 100% - 100px );
        background: #FFFFFF;
        border-radius: 6px;
        padding:20px;
        box-sizing: border-box;
    }
    .user-mess-border{
        width:100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        left:0;
        top:0;
        background: rgba(0,0,0,0.5);
    }
    .user-mess-body > div{
        margin-bottom:20px;
    }
    .head-title{
        font-size: 15px;
        font-weight: bold;
        color: #2E3033;
        text-align: center;
    }
    .flex-between{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .view-hw-bg{
        width:100vw;
        height: 100vh;
        background:rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }
    .view-hw-bg > div{
        background: #ffffff;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        width:100vw;
        height: max-content;
        overflow: hidden;
    }
    .fixed-class{
        position: fixed;
        left:0;
        top:0;
    }
    /* input:-internal-autofill-selected {
        box-shadow: inset 0 0 0 1000px #281840 !important;
        -webkit-text-fill-color: #c0aefa;
    } */
    @media screen and (max-width:374px) {
        .btn-blue-k,.btn-blue{
            padding:0 0.5em;
        }
    }
    .between-center-flex{
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding:10px 15px;
    }
    .confirm-btn{
        font-size: 14px;
        color:#576b95;
    }
    .cancel-btn{
        font-size: 14px;
        color: #969799;
    }
    .title-div-font{
        font-weight: 500;
        font-size: 16px;
    }
    .border-div{
        max-height: 60vh;
        padding: 20px 0;
        width:100vw;
        overflow-y: scroll;
    }
    .border-son-div{
        width:calc( 100vw - 40px );
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        border-bottom:1px solid #E6EAF2;
        box-sizing: border-box;
        margin:0 20px;
    }
    .border-son-div:last-child{
        border-bottom: 0px;
    }
    .now-border-son-div{
        color:#3377FF;
    }
</style>
